import InputCheckbox from "components/page/user/contract/edit/input/inputCheckbox";
import InputDate from "components/page/user/contract/edit/input/inputDate";
import Input from "components/page/user/contract/edit/input/inputNormal";
import { BlockBase, HeadlineHeader } from "components/page/user/contract/edit/parts/blockBase";
import { SEND_OTHER_PAPER } from "constants/messages";
import React from "react";
import Validation from "util/validate";
import InputTextRemark from "../../input/inputTextRemark";

/** 建築確認認証等の発行年月日・番号 */
export default class Block3 extends BlockBase {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            headlineId: "021103",
        };// 入力値のチェック用オブジェクトを生成
        this.validation = new Validation();
    }

    render() {
        const { hideBlockClass, params } = this.renderCommon();

        //JYU01020の入力上限判定
        const JYU01020LimitErrorMessage = this.validation.validateTextAreaWordCount(`JYU01020_${this.props.displayTypeID}`, this.props.pageState.JYU01020);

        // 非表示判定の場合、null(react的な表示なし)を返す
        if (this.dohide(this.props.pageState.hidingHeadline)) { return null; }

        return (
            <div className={`dataList dataList__accordion ${hideBlockClass}`}>
                <div className="dataList-header">
                    <div className="dataList-header-title">建築確認済証等の発行年月日・番号</div>
                    <HeadlineHeader onClick={this.handleHide} hide={this.state.hide} />
                </div>
                <div className="dataList-body">
                    <table className="dataTable">
                        <tbody>
                            <tr>
                                <th className="dataTable-title dataTable-title__left dataTable-title__w211">
                                    <label className="checkBox">
                                        <InputCheckbox id="ID_JYU01014" name="JYU01014" checked={this.props.pageState.JYU01014} {...params} />
                                        <span className="checkBox-text">建築確認（新築時）</span>
                                    </label>
                                </th>
                                <td className="dataTable-body">
                                    <div className="dataTableUnit">
                                        <InputDate eraOnly id="ID_JYU01015" name="JYU01015" value={this.props.pageState.JYU01015} {...params} />
                                        <Input id="ID_JYU01016" name="JYU01016" value={this.props.pageState.JYU01016} {...params} length="wFlexLeftauto" />
                                        <div className="dataTableUnit-text">号</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__left dataTable-title__w211">
                                    <label className="checkBox">
                                        <InputCheckbox id="ID_JYU01017" name="JYU01017" checked={this.props.pageState.JYU01017} {...params} />
                                        <span className="checkBox-text">検査済証（新築時）</span>
                                    </label>
                                </th>
                                <td className="dataTable-body">
                                    <div className="dataTableUnit">
                                        <InputDate eraOnly id="ID_JYU01018" name="JYU01018" value={this.props.pageState.JYU01018} {...params} />
                                        <Input id="ID_JYU01019" name="JYU01019" value={this.props.pageState.JYU01019} {...params} length="wFlexLeftauto" />
                                        <div className="dataTableUnit-text">号</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="dataTable dataTable__border">
                        <tbody>
                            <tr>
                                <th className="dataTable-title dataTable-title__left dataTable-title__w120 dataTable-title__center">備考</th>
                                <td className="dataTable-body" colSpan="3">
                                    <div className="dataTableTextUnit">
                                        <InputTextRemark id="ID_JYU01020" name="JYU01020" value={this.props.pageState.JYU01020} text={SEND_OTHER_PAPER.JYU01020} placeholder={JYU01020LimitErrorMessage.inputLimitGuide} {...params} />
                                        <p className="LengthOver-error">{JYU01020LimitErrorMessage.inputLimitErrorMessage}</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}